import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { dynamicUrl,setDateRange,formatDate } from './Function';
import { useDynamicLink } from './DynamicUse';
import { useTranslation } from 'react-i18next';
import { Container,Row,Col,Card,Tab,Tabs,ListGroup,Placeholder } from 'react-bootstrap';
import Slider from "react-slick";
import './focusUtils';
const DepartmentLatest = ({ sdId }) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const epArray = {1:100,2:103,3:101,5:99,6:102,7:77,9:72,11:104};
    const apArray = {1:138,2:142,3:139,5:137,6:140,7:136,9:71,11:143};
    const rpArray = {1:279,2:282,3:280,5:278,6:281,7:277,9:276,11:283};     
    const epLink = useDynamicLink(epArray[sdId]);
    const apLink = useDynamicLink(apArray[sdId]);
    const rpLink = useDynamicLink(rpArray[sdId]);
    const[Events,setEvents]=useState([]);
    const[isLoading, setLoading] = useState(true);
    const[Achievements,setAchievements]=useState([]);
    const[aLoading, setALoading] = useState(true);
    const[Journals,setJournals]=useState([]);
    const[jLoading, setJLoading] = useState(true);    
    const[Programs,setPrograms]=useState([]);
    const[pLoading, setPLoading] = useState(true);
    const[Pseo,setPseo]=useState([]);
    const[seLoading, setSeLoading] = useState(true);
    useEffect(()=>
    {
        const EventsList = async () => 
        {
            try 
            {                
                var scId = 0;
                var keywordText = 'none';
                var startLimit = 0;
                const { startDate, endDate } = setDateRange(0, 0, 0, 0, 1);
                const callApi = global.config.API_URL + `events/list/${sdId}/${scId}/${keywordText}/${startDate}/${endDate}/${startLimit}`;
                if(global.config.IsPrint) console.info('EventsList : API', callApi);
                const response = await fetch(callApi);
                const result = await response.json();
                setEvents(result);
                if( global.config.IsPrint === true ) { console.info('EventsList : Result',result); }
            } 
            catch (error) 
            {
                console.error('EventsList : Error', error.message);                
            }
            finally
            {
                setLoading(false);
            }
        };
        const AchievementsList = async (e) => 
        {
            try
            {
                var keywordText = 'none';
                var startLimit = 0;
                const { startDate, endDate } = setDateRange(0, 0, 0, 0, 1);
                const callApi = global.config.API_URL + `achievements/list/${sdId}/${keywordText}/${startDate}/${endDate}/${startLimit}`;
                if(global.config.IsPrint) console.info('AchievementsList : API', callApi);
                const response = await fetch(callApi);
                const result = await response.json();
                setAchievements(result);
                if (global.config.IsPrint) console.info('AchievementsList : Result', result);
            } 
            catch (error) 
            {
                console.error('AchievementsList : Error', error.message);                
            }
            finally
            {
                setALoading(false);
            }
        };
        const FacultyByTypeAndDepartment = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"faculty/byUserTypeAndDepartment/1/"+sdId);
                const result = await response.json();
                const suIds = result.map(item => item.su_id).join(',');
                //console.info('Faculties Ids : ', suIds);
                await DepartmentJournals(suIds);                            
                if( global.config.IsPrint === true ) { console.info('FacultyByTypeAndDepartment : Result',result); }
            } 
            catch (error) 
            {
                console.error('FacultyByTypeAndDepartment : Error', error.message);
            }
        };        
        const DepartmentJournals = async (suIds) => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"journal/list/"+suIds+"/0/10");
                const result = await response.json();
                setJournals(result);                            
                if( global.config.IsPrint === true ) { console.info('DepartmentJournals : Result',result); }
            } 
            catch (error) 
            {
                console.error('DepartmentJournals : Error', error.message);
            }
            finally
            {
                setJLoading(false);
            }
        };        
        const DepartmentPrograms = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programs/byDepartment/"+sdId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.p_id + "/programImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.p_id + "/programImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].programImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].programImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setPrograms(result);
                    }).catch(error => 
                    {
                        console.error('Programs Image :', error);
                    });
                }
                if( global.config.IsPrint === true ) { console.info('Programs : Result',result); }
            } 
            catch (error) 
            {
                console.error('Programs : Error', error.message);                
            }
            finally
            {
                setPLoading(false);
            }
        };
        const PseoByDepartment = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"departmentsPseo/byDepartment/"+sdId);
                const result = await response.json();
                setPseo(result);              
                if( global.config.IsPrint === true ) { console.info('PseoByDepartment '+sdId+' : Result',result); }
            } 
            catch (error) 
            {
                console.error('PseoByDepartment '+sdId+' : Error', error.message);                
            }
            finally
            {
                setSeLoading(false);
            }
        };        
        EventsList();
        AchievementsList();
        FacultyByTypeAndDepartment();
        DepartmentPrograms();
        PseoByDepartment();
        window.disableFocusInHiddenSlides();
        window.enableFocusInVisibleSlides();
        // eslint-disable-next-line react-hooks/exhaustive-deps     
    },[sdId])
    const settings = 
    {
        autoplay: true,
        centerMode: false,
        infinite: true,
        centerPadding: "0px",
        dots: false,
        slidesToShow: 4,
        speed: 500,
        accessibility: true,
        beforeChange: (current, next) => { window.disableFocusInHiddenSlides(); },
        afterChange: current => { window.enableFocusInVisibleSlides(); },
        responsive: [{ breakpoint: 1024,settings: { slidesToShow: 1 }} ]
    };
    const groupedData = Pseo.reduce((acc, item) => 
    {
        const pt_id = item.programType.pt_id;
        if (!acc[pt_id]) { acc[pt_id] = []; }
        acc[pt_id].push(item);
        return acc;
    }, {});
    function stripTags(html) { return html.replace(/<\/?[^>]+(>|$)/g, ""); }
    return (
        <React.Fragment>
            <Container className='py-md-5 py-3'>
                <Row>
                    <Col md={4}>
                        <Card className='shadow h-100'>
                            <h4 className='my-2'>{t('Events')}</h4>
                            <span className="mx-auto mb-0 sub-heading"></span>
                            {isLoading ? (
                                <Card.Body>
                                {[...Array(10)].map((_,index) => (
                                    <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                                        <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                            <i className="bi bi-calendar3"></i>
                                        </span>
                                        <div>
                                            <Placeholder xs={12} />
                                            <Placeholder xs={6} bg="secondary" />
                                        </div>
                                    </ListGroup.Item>
                                ))}
                                </Card.Body>
                            ) : (
                                <React.Fragment>
                                {Events.length === 0 ? (
                                    <Card.Body>
                                        <big>{appLanguage === 'hi' ? 'कोई कार्यक्रम नहीं मिला.' : 'There is no event found.'}</big>
                                    </Card.Body>
                                ) : (
                                    <Card.Body className='text-start overflow-hidden overflow-y-auto' style={{height:"300px"}}>
                                        <ListGroup variant="flush">
                                        {Events.map((se,index)=>(
                                            <NavLink key={index} to={appLanguage ==='hi' ? `/घटनाक्रम/विवरण/${se.se_htaccess_hi || se.se_htaccess}` : `/event/details/${se.se_htaccess}`} className='list-group-item list-group-item-action d-flex align-items-start px-0' target='_blank' rel="noopener noreferrer">
                                                <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                                    <i className="bi bi-calendar3"></i>
                                                </span>
                                                <div>
                                                    <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (se.se_display_en === "1" ? se.se_name_hi || '' : se.se_name_hi || se.se_name) : se.se_name }}></div>
                                                    <div className='text-secondary'>{formatDate(se.se_start_duration)} TO {formatDate(se.se_end_duration)}</div>
                                                </div>
                                            </NavLink>
                                        ))}
                                        </ListGroup>
                                    </Card.Body>                                  
                                )}
                                </React.Fragment>
                            )}                        
                            <Card.Footer className='text-start bg-transparent border-0'>
                            {epLink && epLink.length > 0 && epLink.map((sp,index)=>(
                                <NavLink to={dynamicUrl(sp)} className='fw-bold' key={index}>
                                    {appLanguage === 'hi' ? 'सभी देखें' : 'View All'} <i className="bi bi-chevron-right"></i>
                                </NavLink>
                            ))}
                            </Card.Footer>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className='shadow h-100'>
                            <h4 className='my-2'>{appLanguage === 'hi' ? 'उपलब्धियां' : 'Achievements'}</h4>
                            <span className="mx-auto mb-0 sub-heading"></span>
                            {aLoading ? (
                                <Card.Body>
                                {[...Array(10)].map((_,index) => (
                                    <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                                        <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                            <i className="bi bi-award-fill"></i>
                                        </span>
                                        <Placeholder xs={10} bg="success" />
                                    </ListGroup.Item>
                                ))}
                                </Card.Body>
                            ) : (
                                <React.Fragment>
                                { Achievements.length === 0 ? (
                                    <Card.Body>
                                        <big>{appLanguage === 'hi' ? 'कोई उपलब्धि नहीं मिली है।' : 'There is no achievement found.'}</big>
                                    </Card.Body>
                                ) : (
                                    <Card.Body className='text-start overflow-hidden overflow-y-auto' style={{height:"300px"}}>
                                        <ListGroup variant="flush">
                                        {Achievements.map((sa,index)=>(
                                            <NavLink key={index} to={appLanguage === 'hi' ? `/उपलब्धि/विवरण/${sa.sa_htaccess_hi || sa.sa_htaccess}` : `/achievement/details/${sa.sa_htaccess}`} className='list-group-item list-group-item-action d-flex align-items-start px-0' target='_blank' rel="noopener noreferrer">
                                                <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                                    <i className="bi bi-award-fill"></i>
                                                </span>                                            
                                                <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? sa.sa_name_hi || sa.sa_name : sa.sa_name }}></div>
                                            </NavLink>
                                        ))}
                                        </ListGroup>
                                    </Card.Body>                                  
                                )}
                                </React.Fragment>
                            )}                        
                            <Card.Footer className='text-start bg-transparent border-0'>
                                {apLink && apLink.map((sp,index)=>(
                                    <NavLink to={dynamicUrl(sp)} className='fw-bold' key={index}>
                                        {appLanguage === 'hi' ? 'सभी देखें' : 'View All'} <i className="bi bi-chevron-right"></i>
                                    </NavLink>
                                ))}
                            </Card.Footer>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className='shadow h-100'>
                            <h4 className='my-2'>{appLanguage === 'hi' ? 'रिसर्च कॉर्नर' : 'Research Corner'}</h4>
                            <span className="mx-auto mb-0 sub-heading"></span>
                            {jLoading ? (
                                <Card.Body>
                                {[...Array(10)].map((_,index) => (
                                    <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                                        <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                            <i className="bi bi-journal-bookmark-fill"></i>
                                        </span>
                                        <Placeholder xs={10} bg="success" />
                                    </ListGroup.Item>
                                ))}
                                </Card.Body>
                            ) : (
                                <React.Fragment>
                                { Journals && Journals.length === 0 ? (
                                    <Card.Body>
                                        <big>{appLanguage === 'hi' ? 'कोई पत्रिका नहीं मिली।' : 'There is no journal found.'}</big>
                                    </Card.Body>
                                ) : (
                                    <Card.Body className='text-start overflow-hidden overflow-y-auto' style={{height:"300px"}}>
                                        <ListGroup variant="flush">
                                        {Journals.map((sj,index)=>(
                                            <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                                                <span className='px-3 py-2 border rounded bg-info-subtle text-info'>
                                                    <i className="bi bi-journal-bookmark-fill"></i>
                                                </span>
                                                <div className='ms-3 w-100'>
                                                    <span className="me-1">{(sj.sj_authors_hi || sj.sj_authors) && (appLanguage === 'hi' ? sj.sj_authors_hi || sj.sj_authors : sj.sj_authors) + ','}</span>
                                                    <span className="fw-bold me-1">{(sj.sj_name_hi || sj.sj_name) && (appLanguage === 'hi' ? sj.sj_name_hi || sj.sj_name : sj.sj_name) + ','}</span>
                                                    <span className="me-1">{(sj.sj_description_hi || sj.sj_description) && stripTags(appLanguage === 'hi' ? sj.sj_description_hi || sj.sj_description : sj.sj_description) + ','}</span>                                                    
                                                    <span className="me-1">{sj.sj_volume && sj.sj_volume +','}</span>
                                                    <span className="me-1">{sj.sj_page_no && sj.sj_page_no + ','}</span>
                                                    <span className="me-1">{sj.sj_date && formatDate(sj.sj_date)}</span>
                                                </div>                       
                                            </ListGroup.Item>
                                        ))}
                                        </ListGroup>
                                    </Card.Body>                                  
                                )}
                                </React.Fragment>
                            )}                        
                            <Card.Footer className='text-start bg-transparent border-0'>
                            {rpLink && rpLink.map((sp,index)=>(
                                <NavLink to={dynamicUrl(sp)} className='fw-bold' key={index}>
                                    {appLanguage === 'hi' ? 'सभी देखें' : 'View All'} <i className="bi bi-chevron-right"></i>
                                </NavLink>
                            ))}
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>            
            </Container>
            <section className="programs-offered">
                <div className='background'>
                    <Container className='py-md-5 py-3'>
                        <h3 className='text-start mb-4'>{ appLanguage === 'hi' ? 'हमारे द्वारा प्रस्तावित कार्यक्रम' : 'Programs We offer'}</h3>
                        {pLoading ? (
                        <div className="slider-container px-4 py-3" data-aos="fade-up" data-aos-duration="1500">
                            <Slider {...settings}>
                                {[...Array(5)].map((_,index)=>(
                                <Card className='text-center card-custom' key={index}>
                                    <Placeholder xs={12} className="card-img-top" style={{minHeight:"160px"}} />
                                    <Card.Body>
                                        <Placeholder xs={10} />
                                    </Card.Body>
                                    <Card.Footer className='text-bg-info'>
                                        <Placeholder xs={10} />
                                    </Card.Footer>
                                </Card>
                                ))}
                            </Slider>
                        </div>
                        ) : (
                        <div className="slider-container py-3" data-aos="flip-up" data-aos-duration="1500">
                            <Slider {...settings}>
                                {Programs.map((sp, index)=>(
                                    <Card className='border-0' key={index}>
                                        {appLanguage === 'hi' ? 
                                            (
                                                sp.programImageHi 
                                                ? <Card.Img src={sp.programImageHi} alt={sp.p_name_hi} loading="lazy" /> 
                                                : sp.programImage 
                                                    ? <Card.Img src={sp.programImage} alt={sp.p_name_hi} loading="lazy" /> 
                                                    : <Placeholder xs={12} className="card-img-top" />
                                            ) : (
                                                sp.programImage 
                                                ? <Card.Img src={sp.programImage} alt={sp.p_name} loading="lazy" /> 
                                                : <Placeholder xs={12} className="card-img-top" />
                                            )
                                        }
                                        <Card.ImgOverlay className='p-0 d-flex align-items-end'>
                                            <Card.Title className='fs-6 card-title h5 mb-5 p-3 text-dark bg-white rounded-end' style={{boxShadow:"#3aafa9 4px 0px 0px 0px"}}>
                                                <NavLink to={appLanguage === 'hi' ? `/प्रोग्राम/विवरण/${sp.p_htaccess_hi || sp.p_htaccess}` : `/program/details/${sp.p_htaccess}`} target='_blank' rel="noopener noreferrer">
                                                { appLanguage === 'hi' ? sp.programType.pt_name_hi || sp.programType.pt_name : sp.programType.pt_name } ({ appLanguage === 'hi' ? sp.p_short_name_hi || sp.p_short_name : sp.p_short_name })
                                                </NavLink>                                                
                                            </Card.Title>
                                        </Card.ImgOverlay>
                                    </Card>                   
                                ))}
                            </Slider>
                        </div>
                        )}
                    </Container>
                </div>
            </section>
            <React.Fragment>
                {seLoading ? (
                    <Container className='py-md-5 py-3'>
                    <h3>{ appLanguage === 'hi' ? 'पीएसओ/पीईओ' : 'PSO/PEO'}</h3>
                    <span className="mx-auto mb-0 sub-heading"></span>
                    <Tabs defaultActiveKey="0">
                    {[...Array(5)].map((_, index)=>(
                    <Tab eventKey={index} key={index} className='text-start' title={<Placeholder xs={10} />}>
                        <Placeholder xs={5} />
                        <Placeholder xs={12} />
                        <Placeholder xs={12} />
                        <Placeholder xs={10} />
                        <Placeholder xs={6} />
                        <Placeholder xs={10} />
                        <Placeholder xs={12} />
                        <Placeholder xs={12} />                        
                    </Tab>
                    ))}
                    </Tabs>
                    </Container>
                ) : (
                    <React.Fragment>
                    {Object.entries(groupedData).length > 0 && (
                        <Container className='py-md-5 py-3'>
                          <h3>{ appLanguage === 'hi' ? 'पीएसओ/पीईओ' : 'PSO/PEO'}</h3>
                          <span className="mx-auto mb-0 sub-heading"></span>
                          <Tabs defaultActiveKey="0">
                            {Object.entries(groupedData).map(([_, items], index) => (                    
                              <Tab 
                                eventKey={index} 
                                key={index} 
                                className='text-start' 
                                title={ appLanguage === 'hi' ? items[0].programType.pt_name_hi + ' ' + items[0].programs.p_short_name_hi : items[0].programType.pt_name + ' ' + items[0].programs.p_short_name}
                              >
                                {items.filter(item => item.pp_type === 1).length > 0 && (
                                  <h5>{ appLanguage === 'hi' ? 'प्रोग्राम विशिष्ट परिणाम' : 'Programme Specific Outcomes'}</h5>
                                )}
                                {items
                                  .filter(item => item.pp_type === 1)
                                  .sort((a, b) => a.pp_sequence - b.pp_sequence)
                                  .map((item, index) => (
                                    <div key={index} className='d-flex mb-2'>
                                      <div className='text-decoration-underline'>{ appLanguage === 'hi' ? 'पीएसओ' + (index + 1) + ':' : 'PSO' + (index + 1) + ':'}</div>                                        
                                      <div className='text-justify ms-2' dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? item.pp_content_hi : item.pp_content }} />
                                    </div>
                                ))}
                                {items.filter(item => item.pp_type === 2).length > 0 && (
                                  <h5>{ appLanguage === 'hi' ? 'प्रोग्राम शैक्षणिक उद्देश्य' : 'Programme Educational Objectives'}</h5>
                                )}
                                {items
                                  .filter(item => item.pp_type === 2)
                                  .sort((a, b) => a.pp_sequence - b.pp_sequence)
                                  .map((item, index) => (
                                    <div key={index} className='d-flex mb-2'>
                                      <div className='text-decoration-underline'>{ appLanguage === 'hi' ? 'पीईओ' + (index + 1) + ':' : 'PEO' + (index + 1) + ':'}</div>
                                      <div className='text-justify ms-2' dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? item.pp_content_hi : item.pp_content }} />
                                    </div>
                                ))}                        
                              </Tab>
                            ))}
                          </Tabs>
                        </Container>
                      )}
                    </React.Fragment>                      
                )}
            </React.Fragment>
        </React.Fragment>      
    );
}
export default DepartmentLatest;